<template>
  <div>
    <el-card>
      <el-form ref="form" label-width="80px" size="mini" :inline="true">
        <el-form-item>
          <el-date-picker v-model="time" type="month" placeholder="月份">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">搜 索</el-button>
          <el-button type="primary">下 载</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      time: ""
    };
  }
};
</script>
<style scoped></style>
